export const EDITING_DOC_SUBSCRIPTION_OPTIONS_MODAL_NAME =
  'EDITING_DOC_SUBSCRIPTION_OPTIONS_MODAL_NAME';
